import React from 'react';

import { Route, Switch } from 'react-router';
import { routes, pagePublicSetting } from '../App-layout';

import NotFound from '../pages/NotFound';
import RouteProtectedHoc from './RouteProtectedHoc';

const RouteManager = () => (
	<Switch>
		{routes &&
			routes
				.filter((r) => {
					if (Object.keys(pagePublicSetting).indexOf(r.name) >= 0) {
						return process.env[pagePublicSetting[r.name].env] === 'true';
					}
					return true;
				})
				.map((route) => (
					<RouteProtectedHoc
						exact
						key={route.id}
						path={route.path}
						name={route.name}
						public={route.public}
						component={route.component}
						withHeader={route.withHeader}
						withFooter={route.withFooter}
					/>
				))}
		<Route component={NotFound} />
	</Switch>
);

export default RouteManager;
